<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/admin_parts_confirm.css" type="text/css" media="all" scoped></style>


<template>
  <div class="contents" id="wirksBulk">
		<!-- ▽ -->
		<section id="mainContent">
			<h2>コースマスタ<span>年度更新</span></h2>
			<ul class="contntMenu">
        <li class="onCancel" v-on:click="onCancel">戻る</li>
			</ul>
			<section class="confirmArea">
					<table class="listTbl">
						<caption>
              <div class="btnLst">
                <button class="newBtn" v-on:click="onRegister">登録</button>
              </div>
						</caption>
            <thead>
              <tr>
                <th>クライアント</th>
                <td>対象年度</td>
                <td>更新年度</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>{{jgnm}}</th>
                <td>{{currentNend}}</td>
                <td>{{nextNend}}</td>
              </tr>
              </tbody>
          </table>
        
			</section>
		</section>
    <!-- モーダルWindow S -->
    <modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
      <dt slot="modal-header">システムエラー</dt>
      <dd slot="modal-body">
        <errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
      </dd>
      <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
    </modalWindow>
    <!-- モーダルWindow E -->
    <!-- モーダルWindow S -->
    <modalWindow v-show="modal.noCourseError.isShow" v-on:close="onNoCourseErrorModalClose">
      <dt slot="modal-header">対象コースエラー</dt>
      <dd slot="modal-body">
        <errorMessageBox :errorMessages="modal.noCourseError.messages"></errorMessageBox>
      </dd>
      <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onNoCourseErrorModalClose">閉じる</a></dd>
    </modalWindow>
    <!-- モーダルWindow E -->
    <!-- モーダルWindow S -->
    <modalWindow v-show="modal.confirmRegister.isShow" v-on:close="onConfirmRegisterModalClose">
      <dt slot="modal-header">確認</dt>
      <dd slot="modal-body">
        <errorMessageBox :errorMessages="modal.confirmRegister.messages"></errorMessageBox>
        <ul class="btnLst">
          <li><button v-on:click="onRegister">OK</button></li>
          <li><button v-on:click="onConfirmRegisterModalClose">キャンセル</button></li>
        </ul>
      </dd>
    </modalWindow>
    <!-- モーダルWindow E -->
    <!-- モーダルWindow S -->
    <modalWindow v-show="modal.registerFinished.isShow" v-on:close="onRegisterFinishedModalClose">
      <dt slot="modal-header">確認</dt>
      <dd slot="modal-body">
        <errorMessageBox :errorMessages="modal.registerFinished.messages"></errorMessageBox>
        <ul class="btnLst">
          <li><button v-on:click="onRegisterFinishedModalClose">閉じる</button></li>
        </ul>
      </dd>
    </modalWindow>
    <!-- モーダルWindow E -->
  </div>
</template>
<script>
  import { WIRKSBulkApi } from '@/api'
  import * as ErrorCodes from '@/components/Utility/error-codes'
  import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
  import ModalWindow from '@/components/Utility/ModalWindow'
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

  export default {
    name: 'MasterWIRKSBulk',
    // 使用コンポーネント
    components: {
      // エラーメッセージ
      errorMessageBox: ErrorMessageBox,
      // モーダルウィンドウ
      modalWindow: ModalWindow
    },
    data() {
      return {
				currentNend: 0,
			  nextNend: 0,
				jgnm: '',
        modal: {
          systemError: {
            messages: [
						  'システムエラーです。',
						  '内容をもう一度ご確認ください。'
					  ],
            isShow: false
          },
          noCourseError: {
            messages: [
						  '選択されたクライアントに紐づくコースがありません。',
					  ],
            isShow: false
          },
          confirmRegister: {
            messages: [
						  '登録しますか？'
					  ],
            isShow: false
          },
          registerFinished: {
            messages: [
              '一括登録が終了しました。'
            ],
            isShow: false
          }
        }
			}
    },
    // ライフサイクルハック　初期化
    created: function () {
      this.firstDisplay()
    },
		methods: {
			// 初期表示
			firstDisplay: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKSBulk::firstDisplay Start')

        // 非同期通信
        WIRKSBulkApi.FirstDisplay({
          token: this.$store.state.auth.token,
          ircd: this.$store.state.auth.ircd,
					jgcd: this.$store.state.adminUserChoice.MasterWIRKS.jgcd
        }).then(({ responce }) => {

          if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						this.currentNend = responce.data.currentNend
						this.nextNend = responce.data.nextNend
						this.jgnm = responce.data.jgnm

          } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_CORRECTION) {
              // 選択されたクライアントに紐づく対象コースがない場合
							// 対象コースエラーモーダルを開く
              this.onNoCourseModalOpen()
          } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
              || responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
              || responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
              // システム、DBエラー時
              this.onSystemErrorModalOpen()
          }
        }).catch(() => {
          this.onSystemErrorModalOpen()
        }).finally(() => {
	        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::firstDisplay End')
	      })
			},
			// 一括登録押下時
			onRegister: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKSBulk::onRegister Start')

				WIRKSBulkApi.Register({
          token: this.$store.state.auth.token,
					nend: this.currentNend,
          ircd: this.$store.state.auth.ircd,
					jgcd: this.$store.state.adminUserChoice.MasterWIRKS.jgcd
        }).then(({ responce }) => {

          this.onConfirmRegisterModalClose()

          if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {
            
            this.onRegisterFinishedModalOpen()

          } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
              || responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
              || responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
              // システム、DBエラー時
              this.onSystemErrorModalOpen()
          }
        }).catch(() => {
          this.onSystemErrorModalOpen()
        }).finally(() => {
	        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::onRegister End')
	      })
			},
      // 戻る押下時
      onCancel: function() {
        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::onCancel Start')

        this.$router.push("/MasterWIRKSList")

        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::onCancel End')
      },
      // システムエラーモーダルとしてエラーモーダルを開く
      onSystemErrorModalOpen: function () {
        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::onSystemErrorModalOpen Start')

        this.modalOpen('systemError')

        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::onSystemErrorModalOpen End')
      },
      // システムエラーモーダルウィンドウを閉じる
      onSystemErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::onSystemErrorModalClose Start')

        this.modalClose('systemError')
        this.$router.push("/AdminLogin")

        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::onSystemErrorModalClose End')
      },
      // 対象コースエラーモーダルを開く
      onNoCourseModalOpen: function () {
        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::onNoCourseModalOpen Start')

        this.modalOpen('noCourseError')

        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::onNoCourseModalOpen End')
      },
      // 対象コースエラーモーダルを閉じる
      onNoCourseErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::onNoCourseErrorModalClose Start')

        this.modalClose('noCourseError')

        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::onNoCourseErrorModalClose End')
      },
      // 更新確認モーダルを開く
      onConfirmRegisterModalOpen: function () {
        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::onConfirmRegisterModalOpen Start')

        this.modalOpen('confirmRegister')

        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::onConfirmRegisterModalOpen End')
      },
      // 更新確認モーダルを閉じる
      onConfirmRegisterModalClose: function () {
        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::onConfirmRegisterModalClose Start')

        this.modalClose('confirmRegister')

        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::onConfirmRegisterModalClose End')
      },
      // 更新正常終了時モーダルとしてモーダルを開く
      onRegisterFinishedModalOpen: function () {
        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::onRegisterFinishedModalOpen Start')

        this.modalOpen('registerFinished')

        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::onRegisterFinishedModalOpen End')
      },
      // 更新正常終了時モーダルウィンドウを閉じる
      onRegisterFinishedModalClose: function () {
        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::onRegisterFinishedModalClose Start')

        this.modalClose('registerFinished')
				this.$router.push("/MasterWIRKSList")

        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::onRegisterFinishedModalClose End')
      },
      // モーダルウィンドウを開く
      modalOpen: function (modalName) {
        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

        this.modal[modalName].isShow = true

        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::modalOpen End')
      },
      // モーダルウィンドウを閉じる
      modalClose: function (modalName) {
        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::modalClose Start')

        this.modal[modalName].isShow = false

        UtilityConsoleLog.consoleLog('MasterWIRKSBulk::modalClose End')
      },
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
		}
  }
</script>


// WEBPACK FOOTER //
// src/components/Admin/Master/WIRKS/MasterWIRKSBulk.vue